// Port of api/fuel/app/classes/filter/search/games/sorts/query/rating/group/gap.php
import F from 'offline/filter/constants'
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'rating.gap.user',
	post: false,
	require: function(config, filter) {
		return sorted('rating.gap.user', filter) > 0 && config.ownerType !== F.OWNER_USER
	},
	run: function(config, filter, data, query) {
		if (!config.userID) return
		query.where('ru.user_id', '=', config.userID)
		query.order('ru.rating_value - ABS(AVG(r.rating_value))', sortReverse('rating.gap.user', filter), sortPriority('rating.gap.user', filter))
	}
}
